/**
 * Central API config with runtime production detection.
 * When the app runs on admin.itskasimproduction.com, always use production API
 * regardless of build-time env (fixes wrong/missing REACT_APP_API_URL in deployed build).
 * When accessed via network IP (e.g. 192.168.x.x with --host), use same host for API.
 */
const PRODUCTION_API = 'https://api.itskasimproduction.com/api';

export function getApiBaseUrl() {
  if (typeof window === 'undefined') {
    return process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
  }
  const host = window.location?.hostname || '';
  if (host.includes('itskasimproduction.com')) {
    return PRODUCTION_API;
  }
  const envUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';
  if (envUrl.startsWith('/') || envUrl.startsWith('.')) return PRODUCTION_API;
  // When accessed via network IP (192.168.x.x, 10.x.x.x), use same host for API so backend is reachable
  if (host && host !== 'localhost' && host !== '127.0.0.1') {
    return `http://${host}:5000/api`;
  }
  return envUrl;
}
